import mutations from './licenceManagement.mutations'
import actions from './licenceManagement.actions'
import getters from './licenceManagement.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
